/* ============================================================
   Beneos Battlemaps : shared behaviour
   Vanilla JS, no framework. Nav scroll state, scroll reveal,
   and a small AJAX cart (drawer + add to cart).
   ============================================================ */
(function () {
  'use strict';

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var cfg = window.Beneos || {};

  /* ---------- nav scroll state ---------- */
  (function () {
    var nav = $('#beneos-nav');
    if (!nav) return;
    var onScroll = function () { nav.classList.toggle('scrolled', window.scrollY > 40); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  })();

  /* ---------- scroll reveal ---------- */
  (function () {
    function revealIn(root) { $$('.reveal', root).forEach(function (n) { n.classList.add('is-in'); }); }

    // In the Shopify theme editor, never hide content behind the scroll animation:
    // edited sections are re-rendered without re-running the observer, so they would
    // otherwise stay opacity:0 ("section disappears on edit"). Reveal everything, and
    // re-reveal any section the editor re-renders.
    if ((window.Shopify && window.Shopify.designMode) || !('IntersectionObserver' in window)) {
      revealIn(document);
      document.addEventListener('shopify:section:load', function (e) { revealIn(e.target); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    function observe(root) {
      $$('.reveal', root).forEach(function (n) { if (!n.classList.contains('is-in')) io.observe(n); });
    }
    observe(document);
    document.addEventListener('shopify:section:load', function (e) { observe(e.target); });
  })();

  /* ---------- money formatting ---------- */
  function formatMoney(cents) {
    var fmt = cfg.moneyFormat || '${{amount}}';
    function withCommas(num) {
      return num.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
    }
    function placeholder(value, precision, thousands, decimal) {
      if (isNaN(value) || value == null) return 0;
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      var num = (cents / 100.0).toFixed(precision);
      var parts = num.split('.');
      var dollars = withCommas(parts[0]).replace(/,/g, thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (match, name) {
      switch (name) {
        case 'amount': return placeholder(cents, 2);
        case 'amount_no_decimals': return placeholder(cents, 0);
        case 'amount_with_comma_separator': return placeholder(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return placeholder(cents, 0, '.', ',');
        case 'amount_with_space_separator': return placeholder(cents, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return placeholder(cents, 0, ' ', '');
        default: return placeholder(cents, 2);
      }
    });
  }

  // Faellt die Bruecke aus, gilt der englische Text. Nie ein Fehler.
  function bt(k, d) { return (window.Beneos && window.Beneos.t) ? window.Beneos.t(k, d) : d; }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /* ---------- cart drawer ---------- */
  var drawer = $('#beneos-cart-drawer');

  function setCount(n) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.setAttribute('data-count', n);
    });
  }

  /* aria-hidden steht fest im Markup und wurde nie umgeschaltet. Der
     Warenkorb war damit auch im geoeffneten Zustand fuer Vorleseprogramme
     nicht vorhanden: acht Positionen, Zwischensumme und der Weg zur Kasse,
     alles unsichtbar. Das Attribut folgt jetzt der Klasse.

     Beide Funktionen sind die einzigen Stellen, die .open setzen und
     entfernen, das Attribut bleibt also zwangslaeufig synchron. Nichts
     anderes wird angefasst: kein Netzaufruf, kein Zustand, keine
     Preislogik.

     Was damit NICHT geloest ist: .bcart-panel traegt role="dialog", und
     ein Dialog braucht Fokus hinein, eine Fokusfalle darin und Fokus
     zurueck. Der Warenkorb ist jetzt lesbar, aber noch nicht bedienbar
     wie ein Dialog. Das ist eine eigene Aufgabe. */
  /* Der Cookie-Hinweis von Shopify liegt als feste Leiste ueber dem unteren
     Fensterrand und damit ueber dem Fuss der Schublade. Vor der Zustimmung nach
     § 356 Abs. 5 BGB fiel dort nur der Link "Your cart" darunter, mit ihren vier
     Zeilen liegt jetzt auch der Checkout-Knopf im verdeckten Bereich, gemessen
     am 2026-08-10: Knopfunterkante bei 1004 von 1080 Pixeln, Leiste ab etwa 960.
     Deshalb bekommt der Fuss unten so viel Abstand, wie die Leiste hoch ist.
     Fehlt sie, weil der Besucher schon entschieden hat, ist der Wert null und
     nichts aendert sich. Die Klassennamen gehoeren Shopify, deshalb der Rueckfall
     auf einen Teilstring und der Wert null bei Misserfolg. */
  function bannerAbstand() {
    if (!drawer) return;
    var b = document.querySelector('.shopify-pc__banner') || document.querySelector('[class*="shopify-pc__banner"]');
    var h = 0;
    if (b) {
      var r = b.getBoundingClientRect();
      if (r.height > 0 && r.bottom >= window.innerHeight - 4) h = Math.round(r.height);
    }
    drawer.style.setProperty('--bcart-banner', h + 'px');
  }

  function openCart() { if (drawer) { bannerAbstand(); drawer.classList.add('open'); drawer.setAttribute('aria-hidden', 'false'); document.documentElement.style.overflow = 'hidden'; } }
  function closeCart() { if (drawer) { drawer.classList.remove('open'); drawer.setAttribute('aria-hidden', 'true'); document.documentElement.style.overflow = ''; } }

  function renderCart(cart) {
    setCount(cart.item_count);
    if (!drawer) return;
    var body = $('#beneos-cart-items', drawer);
    var foot = $('#beneos-cart-foot', drawer);
    if (!body) return;
    if (!cart.item_count) {
      body.innerHTML = '<p class="cart-empty">' + esc(cfg.strings && cfg.strings.cartEmpty || 'Your cart is empty.') + '</p>';
      if (foot) foot.hidden = true;
      return;
    }
    if (foot) foot.hidden = false;
    body.innerHTML = cart.items.map(function (it) {
      // Commerce lines are billed via the price_class variant, so the real pack identity rides on
      // hidden _pack_* line item properties; show that instead of the generic price_class title so
      // the buyer always sees WHAT they bought.
      var props = it.properties || {};
      var isPack = !!props._pack_title;
      var name = isPack ? props._pack_title : it.product_title;
      var url = (isPack && props._pack_url) ? props._pack_url : it.url;
      var img = '';
      if (isPack && props._pack_thumb) {
        img = '<img src="' + props._pack_thumb + '" alt="' + esc(name) + '">';
      } else if (it.image) {
        img = '<img src="' + it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') + '" alt="' + esc(name) + '">';
      }
      var variant = isPack
        ? (props._pack_summary ? '<span class="ci-variant">' + esc(props._pack_summary) + '</span>' : '')
        : ((it.variant_title && it.variant_title !== 'Default Title') ? '<span class="ci-variant">' + esc(it.variant_title) + '</span>' : '');
      return '<div class="ci" data-key="' + it.key + '">' +
        '<a class="ci-img" href="' + url + '">' + img + '</a>' +
        '<div class="ci-main">' +
          '<a class="ci-name" href="' + url + '">' + esc(name) + '</a>' +
          variant +
          '<div class="ci-row">' +
            '<div class="ci-qty">' +
              '<button type="button" data-qty-down aria-label="' + esc(bt('common.qty_down', 'Decrease quantity')) + '">&minus;</button>' +
              '<span>' + it.quantity + '</span>' +
              '<button type="button" data-qty-up aria-label="' + esc(bt('common.qty_up', 'Increase quantity')) + '">+</button>' +
            '</div>' +
            '<span class="ci-price">' + formatMoney(it.final_line_price) + '</span>' +
          '</div>' +
          '<button type="button" class="ci-remove" data-remove>Remove</button>' +
        '</div>' +
      '</div>';
    }).join('');
    var sub = $('#beneos-cart-subtotal', drawer);
    if (sub) sub.textContent = formatMoney(cart.total_price);
  }

  function fetchCart() {
    return fetch((cfg.routes && cfg.routes.cart_url || '/cart') + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(purgeShellLines);
  }

  /* A pack page is a display shell whose own variant costs 0 and carries no package ids. Such a
     line unlocks nothing after checkout; seven real orders did exactly that before 2026-10-28.
     Every legitimate commerce line is a price_class variant with _cloud_upload_ids, so a line
     that is neither, at price 0, is removed before the buyer can check it out. */
  function isShellLine(it) {
    var props = it.properties || {};
    return it.product_type !== 'price_class' && !props._cloud_upload_ids && it.final_price === 0;
  }
  function purgeShellLines(cart) {
    var updates = {};
    var n = 0;
    (cart.items || []).forEach(function (it) { if (isShellLine(it)) { updates[it.key] = 0; n++; } });
    if (!n) return cart;
    return fetch((cfg.routes && cfg.routes.cart_update_url || '/cart/update') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (r) {
      // A failed update leaves the cart as it was; never report it as cleaned.
      if (!r.ok) return cart;
      return r.json().then(function (next) {
        if (next && next.items && !next.items.some(isShellLine)) next.purged = n;
        return next && next.items ? next : cart;
      });
    }).catch(function () { return cart; });
  }

  function changeLine(key, qty) {
    return fetch((cfg.routes && cfg.routes.cart_change_url || '/cart/change') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  function addToCart(form) {
    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }
    var data = new FormData(form);
    return fetch((cfg.routes && cfg.routes.cart_add_url || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: data
    }).then(function (r) { return r.json(); }).then(function () {
      return fetchCart();
    }).then(function (cart) {
      renderCart(cart);
      openCart();
    }).catch(function () {}).then(function () {
      if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; }
    });
  }

  /* collection sort select */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('select[data-sort-by]');
    if (!sel) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sel.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  /* events */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-cart-toggle]');
    if (toggle) { e.preventDefault(); fetchCart().then(renderCart).then(openCart); return; }
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeCart(); return; }

    var down = e.target.closest('[data-qty-down]');
    var up = e.target.closest('[data-qty-up]');
    var rm = e.target.closest('[data-remove]');
    var row = e.target.closest('.ci');
    if (row && (down || up || rm)) {
      var key = row.getAttribute('data-key');
      var current = parseInt(row.querySelector('.ci-qty span').textContent, 10) || 0;
      var next = rm ? 0 : (down ? current - 1 : current + 1);
      changeLine(key, Math.max(0, next));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeCart();
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-cart-form]');
    if (!form) return;
    e.preventDefault();
    // A pack form belongs to beneos-commerce.js alone. It holds no variant; posting it here
    // would at best add nothing and at worst, on an old cached page, add the 0 price shell.
    if (form.hasAttribute('data-commerce-form')) return;
    addToCart(form);
  });

  /* The cart page renders on the server, so a shell line already in the cart would reach the
     checkout button. Clean it up once and reload, so what the page shows is what gets bought. */
  if (document.querySelector('[data-cart-page]')) {
    // At most one reload per visit: should anything put the line straight back, the page must
    // not reload forever.
    fetchCart().then(function (cart) {
      if (!cart || !cart.purged) return;
      var once = false;
      try { once = sessionStorage.getItem('beneos-shell-purge') === '1'; sessionStorage.setItem('beneos-shell-purge', '1'); } catch (e) { once = true; }
      if (!once) window.location.reload();
    });
  }

  /* expose a tiny API for sections that need it */
  window.Beneos = window.Beneos || {};
  window.Beneos.cart = { open: openCart, close: closeCart, refresh: function () { return fetchCart().then(renderCart); }, add: addToCart, formatMoney: formatMoney };
})();
